import React from "react"
import { graphql } from "gatsby"

import { QueryFragments } from "../GraphQl/queryFragments"

// Components
import { PageMeta } from "../components/pageMeta"
import BlockZone from "../components/blocks/blockZone"

const PageTemplate = ({ data: { page } }) => {
  const { meta, pageBlocks } = page || {}
  return (
    <>
      <PageMeta {...meta} />
      {pageBlocks && <BlockZone {...pageBlocks} />}
    </>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query standardPageQuery($slug: String!) {
    page: sanityPage(slug: { current: { eq: $slug } }) {
      meta {
        ...MetaCardFields
      }
      pageBlocks {
        ...BlockZoneBlocks
      }
    }
  }
`
